import { DropDisplayMoleculeReatom } from "@/app/drop/store/drop-display-molecule.reatom"
import { PriceWrapper } from "@/app/price"
import type { UpdateHighlighterProps } from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"

const minValuableNumber = {
  value: 0.0001,
  label: "<0.0001",
}

export const DropFee = reatomComponent<{ className?: string }>(
  ({ className }) => {
    const { dropFeeAtom } = useMolecule(DropDisplayMoleculeReatom)
    const fee = dropFeeAtom()

    return (
      <PriceWrapper
        currency={fee.currency}
        amount={fee.amount}
        className={className}
        minValuableNumber={minValuableNumber}
        format={getPriceFormat(Number(fee.amount))}
        displayZeroAsFree={false}
      />
    )
  },
  "DropFee",
)

const getPriceFormat = (value: number): UpdateHighlighterProps["format"] => {
  if (value === 0) return { maximumFractionDigits: 0 }
  if (value < 1) return { maximumFractionDigits: 4 }
  if (value < 100) return { maximumFractionDigits: 2 }
  if (value < 10000) return { maximumFractionDigits: 0 }

  return {
    maximumFractionDigits: 1,
    maximumSignificantDigits: 3,
    notation: "compact",
  }
}
